<template>
  <div class="home">
    <div class="wrapper">
      <!-- 左侧 -->
      <div class="info-panel">
        <!-- 轮播图 -->
        <div class="banner">
          <div class="mask mask-bg mask-radius"></div>
          <div class="mask mask-radius"></div>
        </div>
        <!-- 左底部 -->
        <div class="bot-area">
          <!-- 推荐服务 -->
          <div class="service">
            <div class="mask mask-bg mask-radius"></div>
            <div class="mask mask-radius"></div>
          </div>
          <!-- 通知公告 -->
          <div class="notice">
            <div class="mask mask-bg mask-radius"></div>
            <div class="mask mask-radius"></div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="application">
        <div class="application-wrap">
          <div class="app-tab">
            <ul>
              <li :class="{'active': oIndex == -1}" @click="getSubSystemList('', -1)">全部</li>
              <li :class="{'active': oIndex == index}" v-for="(item, index) of categoryList" :key="index" @click="getSubSystemList(item.id,index)">{{item.name}}</li>
            </ul>
          </div>
          <div class="app">
            <ul>
              <li @click="openApplication(item.jumpAddress)" v-for="(item,index) of subCategoryList" :key="index">
                <div class="icon">
                  <img :src="item.icon" alt="" width="32">
                </div>
                <p>{{item.name}}</p>
              </li>
              
              <li style="height:0;"></li>
              <li style="height:0;"></li>
            </ul>
          </div>
        </div>
        <div class="mask mask-bg mask-radius"></div>
        <div class="mask mask-radius"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'Home',
  data() {
    return {
      categoryList: '',
      subCategoryList: '',
      oIndex: -1
    }
  },
  mounted() {
    this.getSystemCategory();
    this.getSubSystemList('', -1);
  },
  methods: {
    openApplication(Url) {
      window.open(Url)
    },
    // 获取系统分类 
    getSystemCategory() {
      this.$http.get('/web/portal/systemCategory/getList')
      .then(data=>{
        this.categoryList = data.data.info;
      })
    },
    // 获取系统列表
    getSubSystemList(id, index) {
      this.oIndex = index;
      this.$http.get('/web/portal/subSystem/getList', {
        params: {
          categoryId: id 
        }
      }).then(data=>{
        this.subCategoryList = data.data.info;
      })
    }
  }
} 
</script>

<style lang="less" scoped>
  .home {
    padding-top: 60px;
    height: 100%;
    background: url('../assets/home-bg2.jpg')no-repeat top;
    box-sizing: border-box;
    .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin:  40px 200px;
      height: 90%;
      box-sizing: border-box;
       .info-panel {
          width: 70%;
          height: 100%;
          .banner {
            position: relative;
            height: 340px;
            border-radius: 12px;
            overflow: hidden;
          }
          .bot-area {
            height: 387px;
            margin-top: 34px;
            display: flex;
            justify-content: space-between;
            .service {
              position: relative;
              width: 30%;
              border-radius: 12px;
              overflow: hidden;
            }
            .notice {
              position: relative;
              width: 67%;
              border-radius: 12px;
              overflow: hidden;
              
            }
          }
       }
       .application {
         position: relative;
         width: 28%;
         height: 100%;
         border-radius: 12px;
         overflow: hidden;
         .application-wrap {
           position: absolute;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           z-index: 9;
           .app-tab {
             height: 50px;
             background: rgba(66, 71, 73, 0.3);
             ul {
               display: flex;
               align-items: center;
               li {
                 padding: 0 28px;
                 line-height: 50px;
                 cursor: pointer;
                 &.active {
                   background: skyblue;
                   color: #fff;
                 }
                 
               }
             }
           }
           .app {
             padding: 30px 15px;
             ul {
               display: flex;
               justify-content: space-around;
               flex-wrap: wrap;
               li {
                 margin-bottom: 28px;
                 width: 100px;
                 height: 80px;
                 background: rgba(66, 71, 73, 0.3);
                 text-align: center;
                 line-height: 60px;
                 color: #fff;
                 border-radius: 6px;
                 cursor: pointer;
                 &>div {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 48px;
                 }
                 p {
                   line-height: 28px;
                 }
               }
             }
           }
         }
       }
    }
  }  

.mask {
  background: rgba(66, 71, 73, 0.3);
  background-attachment: fixed;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
}
.mask-bg {
  background: url('../assets/home-bg2.jpg')no-repeat top center;
  background-attachment: fixed;
  filter: blur(4px)
}
.mask-radius {
  border-radius: 12px;
}
</style>